import { useContext } from "react";
import CalendarContext from ".";

const useCalendar = () => useContext(CalendarContext)!;

export default useCalendar;
